import { Component, EventEmitter, Input, Output } from '@angular/core'
import {Router} from "@angular/router";
import {ApiService} from "../../../services/api.service";
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '@components/button/button.component';
import { Claim } from 'app/interfaces/claim.interface';
import { ClaimActions } from 'app/interfaces/claim-actions';
import { ClaimService } from 'app/services/claim.service';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-score-box',
    templateUrl: './score-box.component.html',
    styleUrl: './score-box.component.scss',
    standalone: true,
    imports: [TranslateModule, ButtonComponent, NgIf],
})
export class ScoreBoxComponent {
    shouldShowContactModal: boolean = false
    @Input() claim: Claim
    claimActions: ClaimActions
    @Input() currentTab: string;
    @Output() onGoToComments = new EventEmitter<void>()

    constructor(private router: Router, private api: ApiService, private claimService: ClaimService) {}

    ngOnInit(): void {
        this.claimActions = this.getClaimActions(this.claim)
    }

    goToCreateClaim() {
        this.router.navigate(['create-order'])
    }

    getClaimActions(claim: Claim): ClaimActions {
        return this.claimService.getClaimActions(claim)
    }
}
